import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { regHandlers, regSaga, action, dispatch } from '../../store';
import { takeEvery, put, call } from 'redux-saga/effects';

regHandlers({
  CONFIRM: (state, { payload }) =>
    state.setIn(['page', 'confirmation'], payload),
  CONFIRM_ACTION_PENDING: state =>
    state.setIn(['page', 'confirmation', 'pending'], true),
  CONFIRM_ACTION_ERROR: (state, { payload }) =>
    state.mergeIn(['page', 'confirmation'], {
      error: payload,
      pending: false,
    }),
  CONFIRM_CLOSE: state => state.deleteIn(['page', 'confirmation']),
  SET_CONFIRMATION_VALUE: (state, { payload }) =>
    state.setIn(['page', 'confirmation', 'value'], payload),
});

regSaga(
  takeEvery('CONFIRM_DECISION', function* ({ payload }) {
    if (typeof payload === 'function') {
      yield put(action('CONFIRM_ACTION_PENDING'));
      try {
        yield call(payload);
        yield put(action('CONFIRM_CLOSE'));
      } catch (e) {
        yield put(action('CONFIRM_ACTION_ERROR', e));
        return;
      }
    } else if (payload) {
      yield put(payload);
    }

    yield put(action('CONFIRM_CLOSE'));
  }),
);

const renderBody = body => (typeof body === 'function' ? body() : body);

const onChange = event => {
  dispatch('SET_CONFIRMATION_VALUE', event.target.value);
};

const ConfirmationModalComponent = props => {
  if (props.confirmation === null) {
    return null;
  }

  const {
    size = 'md',
    title = 'Confirm Action',
    body = 'Are you sure you want to proceed?',
    actionName = 'OK',
    actionType = 'primary',
    confirmationText,
    confirmationTextLabel,
    value = '',
    pending,
    error,
  } = props.confirmation;

  const ok = () => dispatch('CONFIRM_DECISION', props.confirmation.ok);
  const cancel = () => dispatch('CONFIRM_DECISION', props.confirmation.cancel);

  return (
    <Modal
      isOpen={true}
      toggle={cancel}
      size={size}
      wrapClassName="modal-alert"
    >
      <ModalHeader className="modal-header-sm" toggle={cancel}>
        {title}
      </ModalHeader>
      <ModalBody>
        {renderBody(body)}
        {confirmationText && (
          <Fragment>
            <p>
              Please enter the {confirmationTextLabel} ({confirmationText})
              below to confirm.
            </p>
            <input
              className="form-control"
              type="text"
              value={value}
              onChange={onChange}
            />
          </Fragment>
        )}
      </ModalBody>
      <ModalFooter>
        {error && <div className="alert alert-danger">{error}</div>}
        <button
          className={`btn btn-${actionType}`}
          onClick={ok}
          disabled={(confirmationText && value !== confirmationText) || pending}
        >
          {actionName}
        </button>
        <button className="btn btn-link-primary" onClick={cancel}>
          Cancel
        </button>
      </ModalFooter>
    </Modal>
  );
};

export const openModal = options => dispatch('CONFIRM', options);
export const closeModal = () => dispatch('CONFIRM_CLOSE');

const mapStateToProps = state => ({
  confirmation: state.getIn(['page', 'confirmation'], null),
});

export const ConfirmationModal = connect(mapStateToProps)(
  ConfirmationModalComponent,
);
